import { Box, Stack, TextField, Typography } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { luxonFormats, luxonViews } from "../blockTypes";
import { useState } from "react";

type Props = {
  currentBlock: any;
};

const SignatureFieldPreview = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;
  const isName = currentBlock?.config?.name;
  const isAddress = currentBlock?.config?.address;
  const isDate = currentBlock?.config?.date;
  const format = currentBlock?.config?.format;
  const [tempDate, setTempDate] = useState(null);

  return (
    <Stack gap={1}>
      {label && (
        <Typography
          variant="body1"
          sx={{
            fontWeight: "medium",
            color: "text.primary",
          }}
        >
          {label}
        </Typography>
      )}
      {isName && (
        <Stack gap={1}>
          <Stack gap={1}>
            <Typography variant="subtitle1" fontWeight="regular">
              First Name
            </Typography>
            <TextField name="firstName" fullWidth placeholder="First Name" />
          </Stack>
          <Stack gap={1}>
            <Typography variant="subtitle1" fontWeight="regular">
              Last Name
            </Typography>
            <TextField name="lastName" fullWidth placeholder="Last Name" />
          </Stack>
        </Stack>
      )}
      {isAddress && (
        <Stack gap={1}>
          <Typography variant="subtitle1" fontWeight="regular">
            Address
          </Typography>
          <TextField
            multiline
            rows={4}
            name="address"
            fullWidth
            placeholder="Address"
          />
        </Stack>
      )}
      {isDate && (
        <Stack gap={1}>
          <Typography variant="subtitle1" fontWeight="regular">
            Date
          </Typography>

          <DateTimePicker
            format={luxonFormats?.[format]}
            views={luxonViews?.[format]}
            value={tempDate}
            onChange={(newDate) => setTempDate(newDate)}
            slotProps={{
              textField: {
                fullWidth: true,
                InputProps: {
                  readOnly: true,
                  placeholder: "Select date",
                },
              },
              field: {
                readOnly: true,
              },
            }}
          />
        </Stack>
      )}
      <Stack gap={1}>
        <Typography variant="subtitle1" fontWeight="regular">
          Signature
        </Typography>
        <Box
          sx={{
            height: "96px",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            width: "100%",
            p: 1.5,
          }}
        >
          <Typography variant="body1" sx={{ color: "#9CA3AF" }}>
            Sign here
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
};
export default SignatureFieldPreview;
